import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEye } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData, formatDateOnly } from "../../utils/options";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const SettledTable = ({ filteredData = null, permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const [settledData, setSettledData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchsettledData = async () => {
    const userId = localStorage.getItem("id");
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchFormData(
        "get-loan-setteled-inquiries",
        formData,
        "POST"
      );

      if (result) {
        const settled = result.data || [];
        setSettledData(settled);
      }
    } catch (error) {
      console.error("Error fetching settled data:", error);
      Swal.fire("Error", "Failed to fetch settled inquiries", "error");
    } finally {
      Swal.close();
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() => navigate(`/inquiry-settled/history/${id}`)}
                      title="Settled History"
                    >
                      <FiEye size={16} />
                    </span>
                  )}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "customer_name",
      header: () => "Customer name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "payouts_type",
      header: () => " Payouts Type",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "payouts",
      header: () => "Payouts",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "prefer_bank_name",
      header: () => "Prefer Bank",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "PayoutDate",
      header: () => "Payout Date ",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchsettledData();
  }, []);

  useEffect(() => {
    if (Array.isArray(filteredData)) {
      setSettledData(filteredData);
    } else if (filteredData === null) {
      setSettledData([]);
    } else {
      fetchsettledData();
    }
  }, [filteredData]);

  return (
    <>
      <Table data={settledData} columns={columns} />
    </>
  );
};

export default SettledTable;
